import request, { donorRequest } from "./request";

export const getUsers = (query) => request({ url: `/users`, params: query });

export const updateUser = (id, values) =>
  request({ url: `/v2/users/${id}`, method: "put", data: values });

export const registerUser = (values) =>
  request({ url: `/v2/public/users/register`, method: "post", data: values });

export const addDonor = (values) =>
  request({ url: `/v2/public/users/add_donor`, method: "post", data: values });

export const getPhoneAvailable = (query) =>
  request({ url: `/v2/public/users/available`, params: query });

export const changeProfileImage = (id, image) => {
  const data = new FormData();
  data.append("image", image);

  return request({ url: `/users/${id}/image`, method: "post", data });
};

export const resetProfileImage = (id) =>
  request({ url: `/users/${id}/image`, method: "delete" });
